import React from "react";

function LimitInput({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    onChange(inputValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="limitInput" className="form-label">
        Limit
      </label>
      <input type="number" className="form-control" id="limitInput" value={value} onChange={handleChange} min="1" />
    </div>
  );
}

export default LimitInput;
